"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _Checkbox = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Checkbox"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var VideoForm = function VideoForm(_ref) {
  var _onChange = _ref.onChange,
      _ref$state = _ref.state,
      _ref$state$url = _ref$state.url,
      url = _ref$state$url === void 0 ? '' : _ref$state$url,
      _ref$state$poster = _ref$state.poster,
      poster = _ref$state$poster === void 0 ? '' : _ref$state$poster,
      _ref$state$playsInlin = _ref$state.playsInline,
      playsInline = _ref$state$playsInlin === void 0 ? false : _ref$state$playsInlin,
      _ref$state$autoPlay = _ref$state.autoPlay,
      autoPlay = _ref$state$autoPlay === void 0 ? false : _ref$state$autoPlay,
      _ref$state$loop = _ref$state.loop,
      loop = _ref$state$loop === void 0 ? false : _ref$state$loop,
      _ref$state$controls = _ref$state.controls,
      controls = _ref$state$controls === void 0 ? false : _ref$state$controls,
      _ref$state$muted = _ref$state.muted,
      muted = _ref$state$muted === void 0 ? false : _ref$state$muted;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Video URL",
    value: url,
    onChange: function onChange(value) {
      return _onChange({
        url: value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Video thumbnail",
    value: poster,
    onChange: function onChange(value) {
      return _onChange({
        poster: value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Autoplay",
    checked: autoPlay,
    onChange: function onChange(e) {
      return _onChange({
        autoPlay: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Loop",
    checked: loop,
    onChange: function onChange(e) {
      return _onChange({
        loop: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Show Controls",
    checked: controls,
    onChange: function onChange(e) {
      return _onChange({
        controls: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Mute",
    checked: muted,
    onChange: function onChange(e) {
      return _onChange({
        muted: e.target.checked
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    label: "Play Inline",
    checked: playsInline,
    onChange: function onChange(e) {
      return _onChange({
        playsInline: e.target.checked
      });
    }
  }));
};

var _default = VideoForm;
exports["default"] = _default;